export default __webpack_public_path__ + "static/media/girl-fear-forest.eac1ad64.jpg";